export const iconFontAwesomeMapsLandmarkFlag = (
	<i className="fa-solid fa-landmark-flag"></i>
);
